export const initialState={
    products:[{
    name:"Iphone 11",
    description:"    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:1,
    price:670,
    img:"https://store.storeimages.cdn-apple.com/4668/as-images.apple.com/is/iphone11-select-2019-family_GEO_EMEA?wid=882&amp;hei=1058&amp;fmt=jpeg&amp;qlt=80&amp;.v=1567022219953",
    item:1,
    like:false
}
,
    {
    name:"Iphone 12",
    description:"    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:2,
    price:970,
    img:"https://assets.swappie.com/swappie-product-iphone-12-pro-max-pacific-blue.png",
    item:1,
    like:false,
},
{
    name:"Macbook Air",
    description:"    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:3,
    price:1500,
    img:"https://images.macrumors.com/article-new/2020/11/macbook-air-m1-unboxing.jpg",
    item:1,
    like:false,
},
{
    name:"Macbook Pro",
    description:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:4,
    price:1900,
    img:"https://www.notebookcheck.com/fileadmin/Notebooks/News/_nc3/Apple_16_Zoll_MacBook_Pro_wird_nicht_was_wir_erwarten.jpg",
    item:1,
    like:false,
},
{
    name:"Iphone 7 ",
    description:"    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:5,
    price:470,
    img:"https://cdn.idealo.com/folder/Product/5113/0/5113018/s1_produktbild_gross/apple-iphone-7-plus-128gb-schwarz.jpg",
    item:1,
    like:false,
}
,
{
    name:"Mcbook Air",
    description:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:6,
    price:1900,
    img:"https://sm.mashable.com/t/mashable_in/review/m/macbook-ai/macbook-air-late-2020-review-the-one-with-apple-silicon-insi_2quc.960.jpg",
    item:1,
    like:false,
},
{
    name:"Apple Ipad",
    description:"    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:7,
    price:370,
    img:"https://i.computer-bild.de/imgs/1/3/1/3/4/8/4/5/Haende-halten-das-Apple-iPad-10-2-658x370-6c3a4e7fb0662dab.jpg",
    item:1,
    like:false,
}
,
{
    name:"Mcbook Pro",
    description:" Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:8,
    price:2500,
    img:"https://pics.computerbase.de/9/6/8/4/1-ab52b5de3ba879d8/article-1280x720.48f69b74.jpg",
    item:1,
    like:false,
},
{
    name:"Ipad Pro",
    description:"    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed neque animi minima. Soluta hic praesentium corrupti in unde consectetur placeat.",
    id:9,
    price:470,
    img:"https://www.logitech.com/content/dam/logitech/en/products/mobility/slim-folio-pro/gallery/slim-folio-pro-gallery-2-01.png",
    item:1,
    like:false,
}

]
,
cart:[]
    
}